import { MessageCircle } from "lucide-react";
import { useSettings, whatsappLink } from "@/context/SettingsContext";

export function WhatsAppFloat() {
  const settings = useSettings();
  const wa = whatsappLink(settings.whatsapp_number, "Hello Shineni India, I have a bulk denim requirement.");
  if (!wa) return null;

  return (
    <a
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with Shineni India on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1FA855] text-white shadow-lg transition-transform duration-200 hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
